import { Button, Modal } from '@tecma/ds';
import { Trans, useTranslation } from '@tecma/i18n';

import type { Quote } from 'types/quote';

import './send-request-modal.scss';

interface SendRequestModalProps {
  isOpen: boolean;
  onClose: () => void;
  quote: Quote;
  onSubmit: () => void;
}

export const SendRequestModal: React.FC<SendRequestModalProps> = ({ isOpen, onClose, quote, onSubmit }) => {
  const { t } = useTranslation();
  return (
    <Modal className='send-request-modal' isOpen={isOpen} onClose={onClose} closeOnBackDropClick>
      <Modal.Header onClose={onClose} closeIcon title='Choose configuration'></Modal.Header>
      <Modal.Content showScrollShadows>
        <p className='send-request-modal-description'>
          <Trans i18nKey='send-request.description' values={{ quoteName: quote.name }} components={{ span: <span /> }} />
        </p>
      </Modal.Content>
      <Modal.Footer>
        <Button className='send-request-modal-select-configuration-button' onClick={onClose} outlined>
          {t('send-request.button-label.close')}
        </Button>
        <Button className='send-request-modal-select-configuration-button' onClick={onSubmit} color='primary'>
          {t('send-request.button-label.send-request')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
